import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["image"]

  preview(event) {
    this.showImage(event.currentTarget.dataset.imageKey)
  }

  reset() {
    this.showImage("original")
  }

  showImage(key) {
    const selectedImage = this.imageTargets.find((image) => image.dataset.imageKey === key)
      || this.imageTargets.find((image) => image.dataset.imageKey === "original")

    this.imageTargets.forEach((image) => {
      const visible = image === selectedImage
      image.classList.toggle("opacity-0", !visible)
      image.setAttribute("aria-hidden", String(!visible))
    })
  }
}
